<!-- eslint-disable max-len -->
<template>
  <v-card-text>
    <v-row>

      <v-col cols="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Current Health Insurance Carrier</v-list-item-title>
            <v-list-item-subtitle>{{ benefitsPacket.currentHealthCarrier.carrierName }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Renewal Date</v-list-item-title>
            <v-list-item-subtitle>{{ benefitsPacket.currentHealthCarrier.renewalDate }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Total Enrolled Employees</v-list-item-title>
            <v-list-item-subtitle>{{ benefitsPacket.currentHealthCarrier.totalEnrolled }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="6">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Years with current provider</v-list-item-title>
            <v-list-item-subtitle>{{ benefitsPacket.currentHealthCarrier.totalYears }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Self Funded</v-list-item-title>
            <v-list-item-subtitle>{{ convertToBool(benefitsPacket.currentHealthCarrier.selfFunded) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Claims Experience</v-list-item-title>
            <v-list-item-subtitle>{{ benefitsPacket.flags.claimsExperience }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Renewal Rates</v-list-item-title>
            <v-list-item-subtitle>{{ benefitsPacket.flags.renewalRates }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col
        cols="12"
        v-for="(item, index) in benefitsPacket.currentHealthCarrier.insuranceInfoRates"
        :key="index"
      >
        <v-card flat style="background-color: transparent !important">
          <v-card-title class="text-body-1 font-weight-medium">Benefit Plan {{ index + 1 }}</v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row>

              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Plan Name</v-list-item-title>
                    <v-list-item-subtitle>{{ item.planNumber }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Contribution Type</v-list-item-title>
                    <v-list-item-subtitle>{{ item.contributionType }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <!-- Contribution Rates -->
              <v-col cols="2" class="d-flex">
                <v-list-item class="d-flex align-center">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Employee</v-list-item-title>
                    <v-list-item-subtitle>{{ item.contributionEmployeeRate }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="2" class="d-flex">
                <v-list-item class="d-flex align-center">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Spouse</v-list-item-title>
                    <v-list-item-subtitle>{{ item.contributionSpouseRate }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="2" class="d-flex">
                <v-list-item class="d-flex align-center">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Child</v-list-item-title>
                    <v-list-item-subtitle>{{ item.contributionChildRate }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4" class="d-flex">
                <v-list-item class="d-flex align-center">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Family</v-list-item-title>
                    <v-list-item-subtitle>{{ item.contributionFamilyRate }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'CurrentHealthInsuranceCarrier',
  data: () => ({
    temp: null,
  }),
  computed: {
    benefitsPacket() {
      return this.$store.state.benefitsPacket;
    },
  },
  methods: {
    convertToBool(value) {
      // eslint-disable-next-line no-nested-ternary
      return value === 0 ? 'Yes' : value === 1 ? 'No' : "Don't Know";
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item__title, .v-list-item__subtitle {
  white-space: unset !important;
}
</style>
